import { isEmpty, isNull } from 'lodash';
import { CHOICE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import { SUED_PARTY_DRIVER_ID } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import {
  ISuedParty,
  Idetails,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { DETAIL_JUGEMENT_ADD } from 'containers/data-structure';

export const getIsInsuredSuedValue = (value: boolean | null): string | null => {
  if (isNull(value)) return null;

  return value ? CHOICE.YES : CHOICE.NO;
};

export const IsSuedPartyChecked = (
  suedPartyId: number,
  suedParties: ISuedParty[],
): boolean => {
  const found = suedParties?.find((el: any) => el.suedParty === suedPartyId);
  if (found) return true;
  return false;
};

export const IsVehiculeChecked = (
  vehiculeId: string,
  suedParties: ISuedParty[],
): boolean => {
  const driverSuedparty = suedParties.find(
    (el: any) => el.suedParty === SUED_PARTY_DRIVER_ID,
  );
  const found = driverSuedparty?.vehicules.find(
    (el: any) => el.registrationNumber === vehiculeId,
  );
  if (found) return true;
  return false;
};

export const isDriverSelected = (details: Idetails) => {
  const procedureDetails = { ...details };
  return !!procedureDetails[DETAIL_JUGEMENT_ADD.SUED_PARTIES].find(
    (el: ISuedParty) => el.suedParty === SUED_PARTY_DRIVER_ID,
  );
};

export const extractVehicules = (details: Idetails) => {
  const procedureDetails = { ...details };
  const found = procedureDetails[DETAIL_JUGEMENT_ADD.SUED_PARTIES].find(
    (el: ISuedParty) => el.suedParty === SUED_PARTY_DRIVER_ID,
  );
  if (found) return found.vehicules;
  return [];
};
export const addDaysToDate = (date: string, days: number) => {
  if (!isEmpty(date)) {
    const datee = new Date(date);
    datee.setDate(datee.getDate() + days);
    return datee;
  }
  return undefined;
};
/* istanbul ignore next */
export const validationCourtFileNumber = (courtFileNumber: any) => {
  let pattern = /^\d{1,7}\/\d{4}\/\d{4}$/;
  return pattern.test(courtFileNumber);
};
